import { defineComponent as _defineComponent } from 'vue'
import { useDonationFormsStore } from '../store';
import { ElNotification } from 'element-plus';
import descriptor from '../utils/rules'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProceedBtn',
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const _ = globalThis._;

const submit = () => {
  const { $state } = store;
    store.validate({ rules: descriptor, fields: $state })
    .then((res) => {
      store.submit()
    })
    .catch(({fields, errors}) => {
      validation_catch(fields, errors);
    });
};
const validation_catch = (fields, errors) => {
  _.each(fields, (field) => {
    setTimeout(() => {
      ElNotification({
        type: 'error',
        title: "Error",
        message: field[0].message,
        offset: 40,
      });
    }, 300);
  });
};



const __returned__ = { store, _, submit, validation_catch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})